<script>
import DatePicker from "@/components/_Shared/DatePicker";
import TimePicker from "@/components/_Shared/TimePicker";
import ConfirmPeriodAndPrice from "./Steps/ConfirmPeriodAndPrice";
import Professionals from "./Steps/Professionals";

import scrollToMixin from "@/mixins/scrollToMixin";
import timeMixin from "@/mixins/timeMixin";

import moment from "@/utils/moment";
import { mapState, mapActions } from "vuex";

export default {
  mixins: [scrollToMixin, timeMixin],

  data() {
    return {
      fromDate: moment()
        .add(2, "months")
        .toDate(),
      toDate: moment()
        .subtract(1, "days")
        .toDate()
    };
  },

  components: {
    DatePicker,
    TimePicker,
    ConfirmPeriodAndPrice,
    Professionals
  },

  computed: {
    ...mapState("newOrder", [
      "orderToRebook",
      "day",
      "starts_at",
      "ends_at",
      "price",
      "professional",
      "professionals_available"
    ])
  },

  methods: {
    ...mapActions("newOrder", ["setDay", "setStartsAt", "setEndsAt"]),
    selectDay(day) {
      this.setDay(day);
      this.scrollTo("#time-picker");
    },

    selectStartsAt(startsAt) {
      this.setStartsAt(this.$options.filters.intToTime(startsAt));
    },

    selectEndsAt(EndsAt) {
      this.setEndsAt(this.$options.filters.intToTime(EndsAt));
      this.scrollTo("#confirm-period-and-price");
    }
  },
  mounted() {
    this.setDay(moment().toDate());
  }
};
</script>

<template>
  <div class="section" id="PerSchedule">
    <div class="section-body">
      <transition name="fade" mode="out-in">
        <date-picker
          title="ESCOLHA O MELHOR DIA E HORÁRIO"
          :fromDate="fromDate"
          :toDate="toDate"
          :class="{ 'passed-on': day }"
          :day="day"
          @daySelected="selectDay"
        />
      </transition>

      <transition name="fade" mode="out-in">
        <time-picker
          id="time-picker"
          v-show="day"
          :startsAt="parseInt(starts_at)"
          :endsAt="parseInt(ends_at)"
          :class="{ 'passed-on': ends_at }"
          :maxDuration="
            orderToRebook ? orderToRebook.schedule_event.duration / 60 : 8
          "
          @startSelected="selectStartsAt"
          @endSelected="selectEndsAt"
        />
      </transition>

      <transition name="fade" mode="out-in">
        <confirm-period-and-price
          id="confirm-period-and-price"
          v-if="price"
          :class="{ 'passed-on': professionals_available }"
          @scrollTo="scrollTo($event)"
        />
      </transition>

      <transition name="fade" mode="out-in">
        <professionals
          id="professionals"
          v-if="professionals_available"
          title="PROFISSIONAIS DISPONÍVEIS"
          :class="{ 'passed-on': professional }"
          @professionalSelected="$emit('scrollTo', '#additional-informations')"
        />
      </transition>
    </div>
  </div>
</template>

<style scoped>
.schedule {
  padding: 10px 20px 10px 50px;
  background-position: 15px center;
  background-size: 20px;
  background-repeat: no-repeat;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  margin-bottom: 10px;
  user-select: none;
}

.section.passed-on .passed-on {
  opacity: 1;
}

.passed-on {
  opacity: 0.35;
}

.passed-on:hover {
  opacity: 1;
}

.date {
  background-image: url("/static/icon-date.svg");
}
</style>



// WEBPACK FOOTER //
// src/components/PurchaseFlow/PerSchedule.vue